// mesh-evolution.js — Self-Improve DNA module (Agent Zero upgrade)
// Polls evolution-manifest.json for new directives and capabilities.

export function createSelfImprove(simId, witness) {
  let lastVersion = null;

  return {
    simId,
    module: 'Self-Improve',
    poll: async () => {
      try {
        const res = await fetch('/evolution-manifest.json', { cache: 'no-store' });
        if (!res.ok) return { directives: [] };
        const manifest = await res.json();
        if (witness && manifest.version && manifest.version !== lastVersion) {
          lastVersion = manifest.version;
          await witness.emit(`Evolution manifest v${manifest.version} adopted — ${manifest.directives.length} directives active`, 'evolution');
        }
        return manifest;
      } catch {
        return { directives: [] };
      }
    },
  };
}

// SIM manifestation — no SIM goes live without full DNA (Witness + Self-Heal + Self-Improve)
import { createWitness } from './mesh-integrity';
import { createSelfHeal } from './mesh-repair';

export function manifestSim(simId) {
  const witness = createWitness(simId);
  const selfHeal = createSelfHeal(simId, witness);
  const selfImprove = createSelfImprove(simId, witness);
  return {
    simId,
    dna: { witness, selfHeal, selfImprove },
    modules: ['Witness', 'Self-Heal', 'Self-Improve'],
    latticePath: `/lattice/logs/${simId}/`,
    alive: true,
  };
}
